import React from 'react';
import { Navigate, createBrowserRouter, Outlet } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { CloseButton } from 'components/common/Toast';
import SettingsToggle from 'components/settings-panel/SettingsToggle';
import SettingsPanel from 'components/settings-panel/SettingsPanel';

// Layouts
import MainLayout from '../layouts/MainLayout';
import AuthSimpleLayout from '../layouts/AuthSimpleLayout';

// Auth Pages
import Login from '../pages/auth/Login';

// Dashboard Pages
import Dashboard from '../pages/dashboard/Dashboard';

// Admin Pages
import CompanyOnboarding from '../pages/admin/CompanyOnboarding';
import CreateUser from '../pages/admin/CreateUser';
import CompaniesList from '../pages/admin/CompaniesList';
import UsersList from '../pages/admin/UsersList';
import CompanyDetails from '../pages/admin/CompanyDetails';
import CompanyEdit from '../pages/admin/CompanyEdit';
import UserDetails from '../pages/admin/UserDetails';
import UserEdit from '../pages/admin/UserEdit';
import UpgradeRequests from '../pages/admin/UpgradeRequests';

// Manager Pages
import BulkImport from '../pages/manager/BulkImport';
import PropertyGroups from '../pages/manager/PropertyGroups';
import PropertyGroupCreate from '../pages/manager/PropertyGroupCreate';
import PropertyGroupDetails from '../pages/manager/PropertyGroupDetails';
import PropertyUnitDetails from '../pages/manager/PropertyUnitDetails';
import PropertyGroupEdit from '../pages/manager/PropertyGroupEdit';
import PropertyUnitEdit from '../pages/manager/PropertyUnitEdit';
import PropertyUnitCreate from '../pages/manager/PropertyUnitCreate';
import TenantManagement from '../pages/manager/TenantManagement';
import TenantDetail from '../pages/manager/TenantDetail';
import TenantEdit from '../pages/manager/TenantEdit';
import CreateContract from '../pages/manager/CreateContract';
import ContractsList from '../pages/manager/ContractsList';
import ContractDetails from '../pages/manager/ContractDetails';
import ContractEdit from '../pages/manager/ContractEdit';
import AdminFeesSettings from '../pages/manager/BrokerageSettings';
import SystemUtilities from '../pages/manager/SystemUtilities';

// Tenant Pages
import TenantContractDetails from '../pages/tenant/ContractDetails';

// Maintenance Pages
import CreateMaintenanceRequest from '../pages/tenant/CreateMaintenanceRequest';
import MaintenanceRequests from '../pages/tenant/MaintenanceRequests';
import MaintenanceRequestDetails from '../pages/tenant/MaintenanceRequestDetails';
import ManagerMaintenanceRequests from '../pages/manager/MaintenanceRequests';
import ManagerMaintenanceRequestDetails from '../pages/manager/MaintenanceRequestDetails';

// Create router with nested routes
export const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <>
        <Outlet />
        <SettingsToggle />
        <SettingsPanel />
        <ToastContainer
          closeButton={CloseButton}
          icon={false}
          position="bottom-left"
        />
      </>
    ),
    children: [
      {
        path: '/',
        element: <MainLayout />,
        children: [
          { index: true, element: <Navigate to="/dashboard" replace /> },
          { path: 'dashboard', element: <Dashboard /> },
          { path: 'admin/companies/onboard', element: <CompanyOnboarding /> },
          { path: 'admin/companies', element: <CompaniesList /> },
          { path: 'admin/companies/:companyId', element: <CompanyDetails /> },
          { path: 'admin/companies/:companyId/edit', element: <CompanyEdit /> },
          { path: 'admin/users/create', element: <CreateUser /> },
          { path: 'admin/users', element: <UsersList /> },
          { path: 'admin/users/:userId', element: <UserDetails /> },
          { path: 'admin/users/:userId/edit', element: <UserEdit /> },
          { path: 'admin/upgrade-requests', element: <UpgradeRequests /> },
          { path: 'manager/bulk-import', element: <BulkImport /> },
          { path: 'manager/property-groups', element: <PropertyGroups /> },
          { path: 'manager/property-groups/new', element: <PropertyGroupCreate /> },
          { path: 'manager/property-groups/:groupId', element: <PropertyGroupDetails /> },
          { path: 'manager/property-groups/:groupId/edit', element: <PropertyGroupEdit /> },
          { path: 'manager/property-groups/:groupId/units/new', element: <PropertyUnitCreate /> },
          { path: 'manager/units/:unitId', element: <PropertyUnitDetails /> },
          { path: 'manager/units/:unitId/edit', element: <PropertyUnitEdit /> },
          { path: 'manager/tenants', element: <TenantManagement /> },
          { path: 'manager/tenants/:tenantId', element: <TenantDetail /> },
          { path: 'manager/tenants/:tenantId/edit', element: <TenantEdit /> },
          { path: 'manager/contracts', element: <ContractsList /> },
          { path: 'manager/contracts/create', element: <CreateContract /> },
          { path: 'manager/contracts/:contractId', element: <ContractDetails /> },
          { path: 'manager/contracts/:contractId/edit', element: <ContractEdit /> },
          { path: 'manager/settings/admin-fees', element: <AdminFeesSettings /> },
          { path: 'manager/settings/utilities', element: <SystemUtilities /> },
          { path: 'manager/maintenance', element: <ManagerMaintenanceRequests /> },
          { path: 'manager/maintenance/:requestId', element: <ManagerMaintenanceRequestDetails /> },
          { path: 'tenant/contracts/:contractId', element: <TenantContractDetails /> },
          { path: 'tenant/maintenance', element: <MaintenanceRequests /> },
          { path: 'tenant/maintenance/new', element: <CreateMaintenanceRequest /> },
          { path: 'tenant/maintenance/:requestId', element: <MaintenanceRequestDetails /> },
        ]
      },
      {
        path: '/login',
        element: <AuthSimpleLayout />,
        children: [
          { index: true, element: <Login /> }
        ]
      },
      {
        path: '*',
        element: <Navigate to="/dashboard" replace />
      }
    ]
  }
]); 